import { render, staticRenderFns } from "./HospitalAdminAdd.vue?vue&type=template&id=16a74c44"
import script from "./HospitalAdminAdd.vue?vue&type=script&lang=js"
export * from "./HospitalAdminAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports